// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V9IAt","left":"styles_left__Xuaja"};